import { Controller } from "stimulus"
import sortable from "../packs/html5sortable"
import Rails from "@rails/ujs"

export default class extends Controller {
  connect() {
    sortable(this.element, {
      handle: '.handle',
      items: '.playlist-item'
    })
    this.element.addEventListener('sortupdate', this.onSortUpdate.bind(this))
  }

  onSortUpdate(e) {
    const userPlaylistId = this.element.dataset.sortableUserPlaylistIdValue
    const ids = Array.from(this.element.children).map(el => el.id.match(/\d+/)[0])
    
    console.log('Sending data:', { user_playlist_item: ids })
    console.log('URL:', `/user_playlists/${userPlaylistId}/user_playlist_items/sort`)
    
    // Use jQuery for the AJAX call to properly handle array parameters
    $.ajax({
      url: `/user_playlists/${userPlaylistId}/user_playlist_items/sort`,
      type: 'PATCH',
      data: { user_playlist_item: ids },
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
  }
}
